import { FilterUtils } from '@elotech/components';
import { isNumber } from 'common/utils';
import { axios } from 'libs';

const resource = '/orc-unidades';
const defaultSort = {
  sort: 'codigo,asc'
};

export const findAllAutocomplete = (
  searchParam = '',
  pagination,
  sort = defaultSort
) => {
  let search = 'inativo==false';

  if (isNumber(searchParam)) {
    search += ` and unidadeComposta==${searchParam}`;
  } else {
    search += ` and ${FilterUtils.buildFilter(['descricao'])(searchParam)}`;
  }

  return axios.get(resource, {
    params: {
      search,
      ...pagination,
      ...sort
    }
  });
};
